import isLogoFileSelected from '@UI/Pages/Administration/Organizations/Sidebars/LogoSidebar/FormData/constraint/isLogoFileSelected';
import isLogoFileSizeValid from '@UI/Pages/Administration/Organizations/Sidebars/LogoSidebar/FormData/constraint/isLogoFileSizeValid';
import isLogoFileTypeValid from '@UI/Pages/Administration/Organizations/Sidebars/LogoSidebar/FormData/constraint/isLogoFileTypeValid';
import { AbstractValidatedClass, ValidatedClass, constraint } from '@verclam/form-validator';

type LogoFormArgs = {
	file: File | null;
};

/**
 * The field is named `file` to match the server's `fieldErrors.file`. `ignoreNullValue` is
 * deliberately absent: with it, a `null` file would be skipped and the required check never run.
 */
@ValidatedClass()
class LogoFormData extends AbstractValidatedClass<LogoFormArgs> {
	@constraint(isLogoFileSizeValid, () => 'Le logo dépasse la taille autorisée (512 Ko).')
	@constraint(isLogoFileTypeValid, () => 'Le logo doit être une image PNG, JPEG ou WebP.')
	@constraint(isLogoFileSelected, () => 'Le fichier du logo est requis.')
	public readonly file: File | null;

	constructor(data: LogoFormArgs) {
		super(data);
		this.file = data.file;
		Object.freeze(this);
	}

	static createEmpty(): LogoFormData {
		return new LogoFormData({ file: null });
	}

	setFile(file: File | null): this {
		return this.cloneWith({ file } as Partial<LogoFormArgs>);
	}
}

export default LogoFormData;
